// extracted by mini-css-extract-plugin
export var arrows = "_5d-5";
export var decrementer = "_5d-9";
export var disabled = "_5d-3";
export var error = "_5d-1";
export var hiddenText = "_5d-a";
export var incrementer = "_5d-8";
export var input = "_5d-7";
export var inputWrapper = "_5d-0";
export var leadingIcon = "_5d-b";
export var readonly = "_5d-2";
export var regular = "_5d-6";
export var small = "_5d-4";